import { FormattedMessageDiv } from '@odmonorepo/core-components';
import { Stack } from 'react-bootstrap';
import { formatPhone } from '@odmonorepo/odfunctions';
import { getSalesAgentInfo } from 'merchant-api/spiceroad';

type SalesAgentInfoCardProps = React.HTMLAttributes<HTMLDivElement>;

export function SalesAgentInfoCard({ ...props }: SalesAgentInfoCardProps) {
  const { salesAgentInfo, isSalesAgentInfoLoading, isSalesAgentInfoError } = getSalesAgentInfo();
  const formattedPhone = salesAgentInfo?.phone != null ? formatPhone(`${salesAgentInfo?.phone}`) : null;
  const formattedFax = salesAgentInfo?.fax != null ? formatPhone(`${salesAgentInfo?.fax}`) : null;
  if (isSalesAgentInfoError || isSalesAgentInfoLoading) return null
  return (
    <div {...props}>
      <div className="mx-5 mt-1 mb-4">
        <Stack className="fw-bold">
          {salesAgentInfo?.name}
        </Stack>
        <div className="fs-7" >
          <Stack>
            <FormattedMessageDiv id="salesAgent.title.label"></FormattedMessageDiv>
          </Stack>
          <Stack className="text-decoration-none mt-3">
            <a href={'tel:' + formattedPhone}>{formattedPhone}</a>
          </Stack>
          <Stack className="text-decoration-none">
            <a href={`mailto:${salesAgentInfo?.email}`}>{salesAgentInfo?.email}</a>
          </Stack>
          <Stack>
            <FormattedMessageDiv id="salesAgent.fax.label" values={{ faxNumber: formattedFax }} />
          </Stack>
        </div>
      </div>
    </div>
  );
}

export default SalesAgentInfoCard;
